import script from './component-lib.esm2.js';
export { SkeletonProps } from './component-lib.esm2.js';
import normalizeComponent from '../../external/vue-runtime-helpers/dist/component-lib.esm.js';
import createInjector from '../../external/vue-runtime-helpers/dist/inject-style/component-lib.esm.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    style: _vm.styles
  }, _vm._l(_vm.count, function (i) {
    return _c('span', {
      key: i,
      staticClass: "v-skeleton",
      class: _vm.classes
    }, [_vm._v("‌")]);
  }), 0);
};
var __vue_staticRenderFns__ = [];

/* style */
const __vue_inject_styles__ = function (inject) {
  if (!inject) return;
  inject("data-v-eadcb68a_0", {
    source: ".v-skeleton[data-v-eadcb68a]{animation:skeleton-data-v-eadcb68a var(--c-duration) ease-in-out infinite;background-color:var(--c-color);background-image:linear-gradient(90deg,var(--c-gradient));background-repeat:no-repeat;background-size:200px 100%;border-radius:var(--g-border-radius-standard);border-radius:min(var(--g-border-radius-standard),var(--g-border-radius-min));display:inline-block;line-height:1;height:var(--c-height);width:var(--c-width)}.v-skeleton--circle[data-v-eadcb68a]{border-radius:50%}.v-skeleton--block[data-v-eadcb68a],.v-skeleton--block>*[data-v-eadcb68a]{display:block}@keyframes skeleton-data-v-eadcb68a{0%{background-position:-200px 0}100%{background-position:calc(200px + 100%) 0}}",
    map: undefined,
    media: undefined
  });
};
/* scoped */
const __vue_scope_id__ = "data-v-eadcb68a";
/* module identifier */
const __vue_module_identifier__ = undefined;
/* functional template */
const __vue_is_functional_template__ = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__ = /*#__PURE__*/normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, createInjector, undefined, undefined);
var Skeleton = __vue_component__;
export { Skeleton as default };